import { Link } from "react-router-dom";
import DashboardLayout from "../../hocs/layout/DashboardLayout";
import { IconFilter } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { get_historial_list,get_historial_list_page } from "../../redux/actions/historial/historial";
import { connect, useSelector } from "react-redux";
import ModificacionesList from "../../components/Modificaciones/ModificacionesList";
import HistorialList from "../../components/historial/HistorialList";

function Historial({
  get_historial_list,
  get_historial_list_page,
  historial,
  count,
}) {
  const user = useSelector((state) => state.auth.user);
  const [planta, setPlanta] = useState("");

  useEffect(() => {
    if (planta !== "") {
      get_historial_list(planta);
    } else {
      get_historial_list();
    }
  }, [planta]);

  const handleChangePlanta = (e) => {
    setPlanta(e.target.value);
  };

  const [term, setTerm] = useState("");
  const handleChange = (e) => {
    setTerm(e.target.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setTimeout(
      () => (window.location.href = "/averias-produccion-p03/" + term),
      0.2
    );
    setTerm("");
  };
  const refreshData = () => {
    get_historial_list();
  };
  return (
    <DashboardLayout>
      <div className="border-b border-gray-200 dark:border-gray-700 py-5 sm:px-6">
        <div className="flex flex-col flex-wrap lg:flex-row lg:items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-2xl font-medium leading-6 text-gray-900 dark:text-white">
              Historial de Modificaciones de Inventario.
            </h3>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 py-2 lg:py-0">
            <div className="">
              <div className="flex items-center md:max-w-3xl md:mx-auto lg:max-w-none">
                <form onSubmit={(e) => onSubmit(e)} className="w-full">
                  <label htmlFor="search" className="sr-only">
                    Buscar
                  </label>
                  <div className="relative">
                    <button
                      type="submit"
                      className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6 text-gray-400 dark:text-gray-500"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                        />
                      </svg>
                    </button>
                    <input
                      id="search"
                      name="search"
                      required
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      className="block w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Buscar"
                      type="search"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="dropdown dropdown-end">
              <div
                tabIndex={0}
                role="button"
                className="p-1.5 bg-white dark:bg-gray-800 border border-blue-600 rounded"
              >
                <IconFilter stroke="#0096C4" />
              </div>
              <div
                tabIndex={0}
                className="dropdown-content z-[1] menu p-2 shadow bg-white dark:bg-gray-800 rounded-box w-52"
              >
                <div className="flex flex-col gap-y-2">
                  <label className="form-control w-full max-w-xs">
                    <div className="label">
                      <span className="label-text text-gray-900 dark:text-white">
                        Planta
                      </span>
                    </div>
                    <select
                      onChange={handleChangePlanta}
                      value={planta}
                      className="select select-bordered w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white"
                    >
                      <option value="">Elige una opción</option>
                      <option value="01">Planta Principal</option>
                      <option value="02">Planta de los Patios</option>
                      <option value="03">Planta de Envasado</option>
                      <option value="04">Planta de Soplado</option>
                      <option value="05">Bodega</option>
                    </select>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HistorialList
        historial={historial}
        count={count}
        refreshData={refreshData}
        get_historial_list={get_historial_list}
        get_historial_list_page={get_historial_list_page}
      />
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => {
  return {
    historial: state.historial.historial_list,
    count: state.historial.count,
  };
};

export default connect(mapStateToProps, {
  get_historial_list,
  get_historial_list_page,
})(Historial);
